import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';

import { LoginForm } from './LoginForm';
import './login.css';

// The sign-in screen, rebuilt in the investor dashboard's visual language (TL, 2026-09-12): blue
// artwork panel · 8px gold rule · white column with the form centred — the same three pieces as
// investor-dashboard-next/src/pages/Public/Auth/AuthPageLayout, in antd + our own CSS (login.css).
// This file owns only the FRAME and the `?error=` notice; the two steps of the flow live in LoginForm.
//
// It says ADMINISTRATION PANEL twice on purpose (on the artwork and over the form): the investor portal
// and this panel share the brand, and an operator must never wonder which door they are at.

const Login = () => {
  const location = useLocation();
  const { error } = qs.parse(location.search);

  useEffect(() => {
    function checkErrorParam() {
      if (error && error === 'login_required') {
        message.error('Login required');
      }
    }

    checkErrorParam();
  });

  return (
    <div className="admin-login">
      <div className="admin-login__art">
        <div>
          <p className="admin-login__brand-name">Constitution Lending</p>
          <span className="admin-login__brand-kind">Administration panel</span>
        </div>
      </div>
      <div className="admin-login__divider" />
      <div className="admin-login__pane">
        <div className="admin-login__panel">
          <img
            className="admin-login__logo"
            src={`${process.env.PUBLIC_URL}/cm_logo.png`}
            alt="Constitution Management"
          />
          <LoginForm />
          <p className="admin-login__footnote">
            Internal tool. Investors sign in on the investor dashboard, not here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
